import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackPausedVideo.meta';

export type TrackPausedVideoParams = {
  id: string;
};

export const useTrackPausedVideo = () => {
  const { track } = useAnalyticsUtilities();

  const trackPausedVideo = useCallback(
    (params: TrackPausedVideoParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackPausedVideo };
};
